export default __webpack_public_path__ + "static/media/hexagon-inner-11.98d31b34.svg";